/*=========================================================================================
  File Name: moduleCountryMutations.js
  Description: Country Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {

SET_INVESTORS(state, items) {
  
      state.Investors = items;
    } ,

  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.Investors.findIndex((p) => p.Id == itemId)
      state.Investors.splice(ItemIndex, 1)
  },
  SET_INVESTOR_CATEGORIES(state, items) {
    state.InvestorCategories = items;
  },

  SET_INVESTOR_KYC_STATUS(state, items) {
    state.InvestorKYCStatus = items;
  },
      GET_ITEM_BY_ID(state, Investor){
  
    try {
      //const parsedData = JSON.parse(Opportunity.data);
    
      state.Investor = Investor;
    } catch (error) {
      console.error("Failed to parse Investor data JSON:", error);
      state.Investor = {};
    }
  },

  UPDATE_INVESTOR(state, updatedInvestor) {
    const index = state.Investors.findIndex((p) => p.Id === updatedInvestor.Id);
    if (index !== -1) {
      state.Investors.splice(index, 1, updatedInvestor);
    }
  },

TOGGLE_INVESTOR_ACTIVE_STATUS(state, investorId) {
  const index = state.Investors.findIndex(i => i.Id === investorId);
  if (index !== -1) {

    const currentStatus = state.Investors[index].isActive;
    state.Investors[index].isActive = !currentStatus;
    state.Investors[index].IsActive = !currentStatus;
  }
}
}
